import React from 'react'
import { styled } from '@material-ui/core/styles'
import { TextField } from '@material-ui/core'

export const Input = styled(({ id, ...rest }) => (
  <TextField id={id} name={id} variant="outlined" {...rest} />
))(({ theme: { spacing } }) => ({
  '& + .MuiTextField-root': {
    marginTop: spacing(4),
  },
}))
